
import * as commonApis from './commonApis'
import { API_HOST_NAME } from 'constants/SystemConstant';

export const getParameter = (id, callback, callbackErr) => {
    let url = API_HOST_NAME + '/api/reports/total/' + id;
    let token = localStorage.getItem("token")
    commonApis.GET(url, token, '', callback, callbackErr);
}